import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTimezone } from '@uplift/contexts';
import { DateFormats } from '@uplift/constants';
import { CalendarDateService } from '@uplift/services';
import { calendarBookingSlots } from '@uplift/api';


export const useAvailableSlots = (date: string | null | undefined, appointmentDuration: number) => {
  const timezone = useTimezone();

  const { data: slots, isInitialLoading: _isLoading } = useQuery(
    [ 'calendar', date, 'booking-slots', appointmentDuration ] as const,
    async () => {
      const dateObj = CalendarDateService.date.tz(date, DateFormats.ISO_DATE, timezone);

      const bookingSlotsResponse = await calendarBookingSlots({
        datetime_from: dateObj.startOf('day').utc().format(),
        datetime_to: dateObj.endOf('day').add(appointmentDuration - 15, 'minutes').utc().format(),
      });

      return bookingSlotsResponse.available_slots;
    },
    {
      enabled: !!date
    }
  );

  return React.useMemo(() => {
    if (slots) {
      return new Set(slots);
    }

    return new Set<string>();
  }, [ slots ]);
};
